const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

// API Configuration - Use environment variables with fallback to localhost
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3019/';
export const API_URL = process.env.REACT_APP_API_URL || `${BASE_URL}api/`;
export const PROFILE_IMG_PATH = `${BASE_URL}app/uploads/profile/`;
export const LOGO_IMG_PATH = `${BASE_URL}app/uploads/teamlogo/`;

interface ActionType {
  type: string;
  payload: any;
}

export function actionCreator(actionType: string, data: any): ActionType {
  return {
    type: actionType,
    payload: data,
  };
}

interface RequestActionTypes {
  REQUEST?: string;
  SUCCESS?: string;
  FAILURE?: string;
  [key: string]: string | undefined;
}

export function createRequestActionTypes(base: string): RequestActionTypes {
  return [REQUEST, SUCCESS, FAILURE].reduce((requestTypes: RequestActionTypes, type: string) => {
    requestTypes[type] = `${base}_${type}`;
    return requestTypes;
  }, {});
}

interface ApiHeaders {
  'Content-Type': string;
  Authorization: string;
  [key: string]: string;
}

export const jsonApiHeader = (accessToken?: string, ContentType?: string): ApiHeaders => {
  return {
    'Content-Type': ContentType || 'application/json',
    Authorization: localStorage.access_token ? `${localStorage.access_token}` : '',
  };
};

// Simplified helper for getting auth headers
export const getAuthHeaders = (): { 'Content-Type': string; Authorization: string } => ({
  'Content-Type': 'application/json',
  Authorization: localStorage.getItem('access_token') || '',
});

// Multipart form headers for file uploads
export const getMultipartHeaders = (): { 'Content-Type': string; Authorization: string } => ({
  'Content-Type': 'multipart/form-data',
  Authorization: localStorage.getItem('access_token') || '',
});
